/** Contenedor de gráfico / panel. */
export default function ChartCard({ title, children, note }) {
  return (
    <section className="analytics-section">
      {title ? <h2 className="analytics-section-title">{title}</h2> : null}
      {note ? <p className="analytics-section-note">{note}</p> : null}
      <div className="analytics-panel">{children}</div>
    </section>
  );
}
